import { useLayoutEffect } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import aa from 'search-insights';
import { getPersonalisationKey } from '../services/Personalisation';
import config from '../services/Config';

aa('init', {
  appId: config.algoliaAppId,
  apiKey: config.algoliaSearchKey,
  useCookie: false,
});

const userToken = getPersonalisationKey();
if (userToken) {
  aa('setUserToken', userToken);
}

export default function AlgoliaInsightsMiddleware() {
  const { addMiddlewares } = useInstantSearch();

  useLayoutEffect(() => {
    const internalMiddleware = createInsightsMiddleware({ insightsClient: aa });
    const middlewareAdapter = (options: any) => internalMiddleware(options);
    return addMiddlewares(middlewareAdapter);
  }, [addMiddlewares]);

  return null;
}
